import './index.css';
import home from '../../assets/svgs/HomeIcon';
import { useLink } from 'react-router-stack';
import React, { useEffect, useState } from 'react';
import myProfile_icon from '../../assets/svgs/Profile';
import newGames_icon from '../../assets/svgs/NewGamesIcon';
import Constants from '../../constants';
import useWindowOrientation from '../../utilities/hooks/useWindowOrientation';

const tabs = [
  {
    tabName: 'home',
    activeImg: home,
    url: '/'
  },
  {
    tabName: 'new games',
    activeImg: newGames_icon,
    url: '/viewall/newgames'
  },
  {
    tabName: 'favourites',
    activeImg: myProfile_icon,
    url: '/viewall/favourites'
  },
  {
    tabName: 'my profile',
    activeImg: myProfile_icon,
    url: '/my_profile'
  }
];

const BottomBar = () => {
  const [activeTab, setActiveTab] = useState('home');

  const link = useLink();

  useEffect(() => {
    setActiveTabName();
  }, [window.location.pathname]);

  const setActiveTabName = () => {
    tabs.map((item) => {
      if (item['url'] == window.location.pathname) {
        setActiveTab(item['tabName']);
      }
    });
  };

  const iconLoader = (type: any) => {
    switch (type) {
      case 'my profile':
        return <Constants.Svgs.MyProfile fill={'white'} />;

      case 'new games':
        return <Constants.Svgs.NewGames />;
      case 'home':
        return <Constants.Svgs.Home />;
      case 'favourites':
        return <Constants.Svgs.Favourites />;
      default:
        return <Constants.Svgs.Home />;
    }
  };

  const navItemClicked = (url: string) => {
    if (url == '/daily_rewards' || url == '/account' || url == '/offer_wall') {
      link.push(url);
    } else {
      link.push(url);
    }
  };
  const { isLandscape } = useWindowOrientation();

  return (
    <div>
      <ul className={`bottom-tab-nav ${isLandscape ? 'bottom-tab-nav__landscape' : ''}`}>
        {tabs.map((item, key) => {
          const walkThrough =
            item['tabName'] == 'rewards'
              ? 'rewardsWalkThrough'
              : item['tabName'] == 'my profile'
              ? 'myProfileWalkThrough'
              : '';

          return (
            <li key={key}>
              <a
                className={item['tabName'] == activeTab ? 'bottom-tab-nav-item-active' : ''}
                onClick={() => navItemClicked(item['url'])}>
                <div className={`bottomBar_iconBG ${walkThrough}`}>
                  {iconLoader(item['tabName'])}
                </div>
                <span className="bottomTab__title">{item['tabName']}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default React.memo(BottomBar);
